import {uuid} from '@aofl/uuid';
import {CacheManager, cacheTypeEnumerate} from '@aofl/cache-manager';

const storage = new CacheManager(uuid(), cacheTypeEnumerate.MEMORY, 0);
const responseHandler = (event) => {
  if (typeof event !== 'object' || typeof event.data === 'undefined') return;
  const data = event.data;
  const callbacks = UnityAppCall.storage.getCollection();

  for (const key in callbacks) {
    if (callbacks.hasOwnProperty(key)) {
      callbacks[key](data);
    } else {}
  }
};
/**
 * UnityAppCall class
 */
class UnityAppCall {
  /**
   *
   *
   * @readonly
   * @static
   */
  static get storage() {
    return storage;
  }
  /**
   *
   * @param {Object} _params
   * @return {String}
   */
  static prepareQueryString(_params) {
    if (typeof _params !== 'object') {
      throw new Error('invalid params');
    }

    const params = [];

    for (const key in _params) {
      if (!_params.hasOwnProperty(key)) {
        continue;
      }
      params.push(`${key}=${encodeURIComponent(_params[key])}`);
    }

    return params.join('&');
  }

  /**
   *
   * @param {String} _uri
   */
  static makeCall(_uri) {
    if (typeof cefAOFL !== 'undefined' && typeof cefAOFL.UnityMessage !== 'undefined') {
      cefAOFL.UnityMessage(_uri); // eslint-disable-line
    } else {
      window.location = _uri;
    }
  }

  /**
   *
   * @param {Object} parameters
   * @deprecated
   */
  static makeLegacyCall(parameters) {
    try {
      const jsonString = JSON.stringify(parameters);
      const encodeUriString = encodeURIComponent(jsonString);
      const iframe = document.createElement('IFRAME');

      iframe.setAttribute('src', 'uniwebview://' + encodeUriString);
      document.documentElement.appendChild(iframe);
      iframe.parentNode.removeChild(iframe);
      iframe = null;
    } catch (err) {}
  }

  /**
   *
   * @param {String} _schema
   * @param {Object} _params
   */
  static send(_schema, _params = {}) {
    if (!_schema) {
      throw new Error('provide a valid schema');
    }
    let uri = _schema;
    const queryString = UnityAppCall.prepareQueryString(_params);
    if (queryString.length) {
      uri += '?' + queryString;
    }

    UnityAppCall.makeCall(uri);
  }
  /**
   *
   * @param {Function} callback
   * @return {Function}
   */
  static addListener(callback) {
    if (typeof callback !== 'function') return;

    const actionKey = String(callback);
    UnityAppCall.storage.setItem(actionKey, callback);

    if (UnityAppCall.storage.size === 1) {
      window.addEventListener('message', responseHandler);
    }
    return () => {
      UnityAppCall.storage.removeItem(actionKey);
      if (UnityAppCall.storage.size === 0) {
        window.removeEventListener('message', responseHandler);
      }
    };
  }
}

export {
  UnityAppCall
};
